import { Component, OnInit, viewChild, AfterViewInit, inject } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { HeaderModule } from '../header/header.module';
import { ActivatedRoute } from '@angular/router';
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card';

@Component({
  selector: 'app-unauth',
  standalone: true,
  templateUrl: './unauth.component.html',
  styleUrls: ['./unauth.component.scss'],
  imports: [HeaderModule, MatCard, MatCardHeader, MatCardTitle],
})
export class UnauthComponent implements OnInit, AfterViewInit {
  private route = inject(ActivatedRoute);

  unAuthFlag: any;

  readonly headerRef = viewChild<HeaderComponent>('headerRef');

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      console.log('params: %o', params);
      this.unAuthFlag = params['flag'];
      console.log("%s", this.unAuthFlag, "params");
    });
  }

  ngAfterViewInit() {
    this.headerRef().hideTabs = true;
  }
}
